import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { useState } from 'react';
import { IconButton } from '@/components/atoms/Button';

type ShowPasswordProps = {
  typeState: string;
  setTypeState: (state: string) => void;
};

export const ShowPassword = ({ setTypeState, typeState }: ShowPasswordProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleChangeVisible = () => {
    setIsVisible(!isVisible);
    setTypeState(typeState === 'password' ? 'text' : 'password');
  };
  return (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleChangeVisible}
        variant="text"
      >
        {isVisible ? (
          <VisibilityOffOutlined color="action" />
        ) : (
          <VisibilityOutlined color="action" />
        )}
      </IconButton>
    </InputAdornment>
  );
};
